import { SKTProgressBar } from "../../components/SKTProgressBar";
import { API_ENDPOINTS } from "../../config";
import { useAPI } from "../../hooks/APIHook";
import { getFromQueryString } from "../../utils/queryString";

export const ActivateLoginView = ({ goLogin }) => {
  const key = getFromQueryString("a");
  const [activationResult] = useAPI(API_ENDPOINTS.auth.activateAccount(key));

  if (activationResult.status === "ok") {
    goLogin("Tunnus aktivoitu. Nyt voit kirjautua sisään");
  }

  if (activationResult.status === "fail") {
    goLogin("Aktivointikoodi ei kelpaa. Ota yhteys asiakaspalveluun");
  }

  return <SKTProgressBar label="Aktivoidaan tunnusta" />;
};
